import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider, Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {TableEditBar} from '../../../components/TableEditBar';
import {PaginatiorInfo} from '../../../graphql/common.datatypes';
import {WcvDocument} from '../../../graphql/documents.datatypes';
import useRouter from 'use-react-router';
import {getHost} from '../../../graphql/GraphQlProvider';
import {WcvType} from '../../../graphql/logs.datatypes';
import updateDocument, {UpdateDocumentInput} from '../updateDocument.api';
import {useSnackbar} from 'notistack';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
    linkButton: {
        marginRight: theme.spacing(1),
    },
}));

const Results = (props: {
    className?: string,
    documents: WcvDocument[],
    paginatorInfo: PaginatiorInfo,
    setPage: (page: number) => void,
    rowsPerPage: number,
    setRowsPerPage: (rowsPerPage: number) => void,
    selectedDocument?: WcvDocument,
    setSelectedDocument?: (document: WcvDocument) => void,
    showViewAndVerify?: boolean
    isAdmin?: boolean
}) => {
    const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, selectedDocument, setSelectedDocument, documents, showViewAndVerify, isAdmin, ...rest} = props;
    const classes = useStyles();
    const {history} = useRouter();
    const {enqueueSnackbar} = useSnackbar();
    const [sendUpdateDocument] = updateDocument();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setRowsPerPage(Number(event.target.value));
    };

    const showGroupMembers = documents.filter(doc => !!doc.targetGroupMember).length > 0;


    const handleVerifyDocument = (document: WcvDocument,) => {
        const sanitisedData: UpdateDocumentInput = {
            data: {
                __typename: undefined,
                user: undefined,
                targetResource: undefined,
                targetGroup: undefined,
                targetGroupMember: undefined,
                completed_documents: undefined,
                overdueGroupMembers: undefined,

                id: document.id,
                verified: true,
            }
        };

        sendUpdateDocument({variables: sanitisedData})
            .then(() => {
                enqueueSnackbar('Document Verified.', {variant: 'success'});
            })
            .catch(() => {
                enqueueSnackbar('Verify Document Failed!', {variant: 'error'});
            });
    };

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                <CardHeader
                    title={'Documents'}
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Title</TableCell>
                                        <TableCell>Description</TableCell>
                                        {showGroupMembers && (<TableCell>Group Member</TableCell>)}
                                        {showViewAndVerify && (<TableCell>Actions</TableCell>)}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {documents.map(document => {
                                        const memberDoc = (document.type === WcvType.GROUP_MEMBER) && document;

                                        return (
                                            <TableRow
                                                hover
                                                key={document.id}
                                                selected={selectedDocument === document}
                                                // onClick={() => { if(!memberDoc) history.push('/documents/' + document.id) } }
                                                onClick={() => {
                                                    if(setSelectedDocument) {
                                                        setSelectedDocument(document)
                                                    }else{
                                                        if(!memberDoc) history.push('/documents/' + document.id)
                                                    }
                                                }}
                                            >
                                                <TableCell>{document.title}</TableCell>
                                                <TableCell>{document.description}</TableCell>
                                                {showGroupMembers && (
                                                    <TableCell>{document.targetGroupMember && (document.targetGroupMember.first_name + ' ' + document.targetGroupMember.last_name)}</TableCell>)}
                                                {showViewAndVerify && (<TableCell>

                                                    {memberDoc && (<Link href={getHost() + document.url} target="_blank">
                                                        <Button variant="contained"
                                                                className={classes.linkButton}>View</Button>
                                                    </Link>)}
                                                    {memberDoc && isAdmin && !document.verified && (
                                                                <Button variant="contained"
                                                                        className={classes.linkButton}
                                                                        onClick={() => handleVerifyDocument(document)}
                                                                >Verify</Button>
                                                            )}

                                                </TableCell>)}
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                <CardActions className={classes.actions}>
                    <TablePagination
                        component="div"
                        count={paginatorInfo.total}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                        page={paginatorInfo.currentPage - 1}
                        rowsPerPage={rowsPerPage}
                        rowsPerPageOptions={[25, 50, 100]}
                    />
                </CardActions>
            </Card>
            <TableEditBar selected={[]}/>
        </div>
    );
};

export default Results;
